import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const FAQS = [
  {
    q: "Do you provide the alcohol?",
    a: "Yes — we can purchase and supply everything, or you can buy your own and we'll mix. Top Shelf and Bar None include a spirits consultation so you buy exactly the right amount, nothing more.",
  },
  {
    q: "What does the deposit cover?",
    a: "The deposit reserves your date and applies toward your package total. The remaining balance is due on event day.",
  },
  {
    q: "Is the deposit refundable?",
    a: "Deposits are refundable up to 14 days before your event. A 10% hold fee will be accrued to reservations cancelled 72 hours after booking.",
  },
  {
    q: "How far in advance should I book?",
    a: "Most dates book 3–4 weeks out. If your event is sooner, submit a request anyway — we can often make it work with 72 hours' notice.",
  },
  {
    q: "What does my venue need to provide?",
    a: "A sturdy table or bar space, access to power, and a water source. We bring the rest — ice, glassware, garnish, and the bartenders.",
  },
  {
    q: "Do you travel?",
    a: "We serve all of Saint Louis and surrounding areas, including Illinois — up to 25 miles outside of downtown STL.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="eyebrow mb-5">FAQ</p>
            <h2 className="font-display text-4xl md:text-5xl tracking-tight text-[#F5F5F5]">
              Before you <em className="italic text-[#D98B48]">ask</em>.
            </h2>
            <p className="mt-5 text-sm text-[#A3A3A3] font-light max-w-xs">
              Anything else on your mind? Include it in the notes on your booking
              request.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-white/10">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i + 1}`}
                    className="font-display text-xl md:text-2xl text-[#F5F5F5] hover:text-[#D98B48] hover:no-underline py-6 text-left"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-[#A3A3A3] font-light leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
